export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8566.dd6027b3.jpg";